import * as React from 'react';
import { useSelector } from 'react-redux';
import { SYSTEM_PERMISSIONS } from 'src/permissionsTypes';
import * as Types from '../../types';

interface Props {
  children: React.ReactNode;
}

const isAuthenticated = (session: string | null | undefined): boolean => {
  if (session === undefined) {
    return false;
  }

  return true;
};

export const isAllowedToViewReports = (user: Types.User | null): boolean => {
  if (user === null) {
    return false;
  }

  if (
    user.systemPermissions &&
    (user.systemPermissions.includes('CREATE_NEW_REPORT') ||
      user.systemPermissions.includes('CREATE_EXISTING_REPORT'))
  ) {
    return true;
  }

  return false;
};

const isExpired = (session: string | null | undefined): boolean => {
  if (session === null) {
    return true;
  }

  return false;
};

export const AuthorisedManager: React.FC<Props> = (props) => {
  const currentUser = useSelector(
    (state: Types.State) => state.globalUsers.currentUser,
  );
  const session = useSelector(
    (state: Types.State) => state.globalUsers.session,
  );
  if (!isAuthenticated(session)) {
    return null;
  }

  if (isExpired(session)) {
    return null;
  }

  if (!isAllowedToViewReports(currentUser)) {
    return null;
  }

  return <>{props.children}</>;
};

export const AuthorisedNewReportCreation = () => {
  const currentUser = useSelector(
    (state: Types.State) => state.globalUsers.currentUser,
  );
  const session = useSelector(
    (state: Types.State) => state.globalUsers.session,
  );
  if (!isAuthenticated(session)) {
    return false;
  }

  if (isExpired(session)) {
    return false;
  }

  if (currentUser === null) {
    return false;
  }

  if (!currentUser.systemPermissions?.includes('CREATE_NEW_REPORT')) {
    return false;
  }

  return true;
};

export const AuthorizedExistReportCreation = () => {
  const currentUser = useSelector(
    ({ globalUsers }: Types.State) => globalUsers.currentUser,
  );
  const session = useSelector(
    ({ globalUsers }: Types.State) => globalUsers.session,
  );
  if (!isAuthenticated(session)) {
    return false;
  }

  if (isExpired(session)) {
    return false;
  }

  if (currentUser === null) {
    return false;
  }

  if (
    !currentUser.systemPermissions?.includes(
      SYSTEM_PERMISSIONS.CREATE_EXISTING_REPORT,
    )
  ) {
    return false;
  }

  return true;
};
